import React, { useState } from "react";
import "./style.scss";
import Checkbox from "../checkbox";

interface Item {
    id: string | number;
    label: string;
    subLabel?: string;
}

interface SearchableDropdownProps {
    open: boolean;
    onClose: () => void;
    data: Item[];
    placeholder?: string;
    selectedIds: (string | number)[];
    onToggle: (item: Item, checked: boolean) => void;
}

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({
    open,
    data,
    placeholder = "Search...",
    selectedIds,
    onToggle,
}) => {
    const [searchTerm, setSearchTerm] = useState("");

    if (!open) return null;

    const filtered = data.filter(
        (item) =>
            item.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(item.id).includes(searchTerm)
    );

    return (
        <div className="assignee-dropdown">
            <input
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />

            <div className="members-list">
                {filtered.length > 0 ? (
                    filtered.map((item) => (
                        <div key={item.id} className="member-item">
                            <Checkbox
                                checked={selectedIds.includes(item.id)}
                                onChange={(e) =>
                                    onToggle(item, e.target.checked)
                                }
                            >
                                <span>{item.label}</span>
                                {item.subLabel && (
                                    <span style={{ color: "#888", marginLeft: 8 }}>
                                        {item.subLabel}
                                    </span>
                                )}
                            </Checkbox>
                        </div>
                    ))
                ) : (
                    <span className="no-results">No results</span>
                )}
            </div>
        </div>
    );
};

export default SearchableDropdown;
